import { useEffect, useRef } from 'react';

const publisherLogos = [

  {
    id: 1,
    image: '/site-images/1633f5bd5e8579b2f829.png',
    invert: true,
  },
  {
    id: 2,
    image: '/site-images/baeb4c29389a42555aa8.png',
    invert: true,
  },
  {
    id: 3,
    image: '/site-images/485dabf4435d2cda6b72.png',
    invert: true,
  },
  {
    id: 4,
    image: '/site-images/a135855e434420e2d0a3.png',
    invert: true,
  },
  {
    id: 5,
    image: '/site-images/d5fa6ae66d29e6536195.png',
    invert: true,
  },
  {
    id: 6,
    image: '/site-images/598407e9c93bc3180862.png',
    invert: true,
  },
];

// Marquee'nin kesintisiz dönmesi için listeyi iki kere çoğaltıyoruz
const logoItems = [...publisherLogos, ...publisherLogos];

export default function PublisherMarquee() {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    let animationId: number;
    let offset = 0;

    const step = () => {
      offset -= 0.4;
      const halfWidth = el.scrollWidth / 2;
      if (Math.abs(offset) >= halfWidth) {
        offset = 0;
      }
      el.style.transform = `translateX(${offset}px)`;
      animationId = requestAnimationFrame(step);
    };

    animationId = requestAnimationFrame(step);
    return () => cancelAnimationFrame(animationId);
  }, []);

  return (
    <section className="py-16 lg:py-20 bg-stone-50 overflow-hidden">
      <div className="relative w-full">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-stone-50 to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-stone-50 to-transparent z-10 pointer-events-none" />

        <div
          ref={scrollRef}
          className="flex items-center will-change-transform"
          style={{ width: 'max-content' }}
        >
          {logoItems.map((logo, index) => (
            <div
              key={`${logo.id}-${index}`}
              className="flex-shrink-0 mx-10 lg:mx-14 flex items-center justify-center"
              style={{ width: '240px', height: '96px' }}
            >
              <img
                src={logo.image}
                alt="Publisher logo"
                className="max-h-[72px] w-auto object-contain"
                style={logo.invert ? { filter: 'invert(1)' } : undefined}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
